import { keyframes, styled } from '@mui/system'
import { TTheme } from '@/core/theme'

const gradientAnimation = keyframes`
    0% {
        background-position: 0% 50%;
    }
    50% {
        background-position: 100% 50%;
    }
    100% {
        background-position: 0% 50%;
    }
`

export const Pulsate = styled('div')<{ theme?: TTheme }>`
    background: linear-gradient(
        -45deg,
        ${({ theme }) => theme?.colors.greys[200] || '#E6E6E6'},
        ${({ theme }) => theme?.colors.greys[100] || '#F2F2F2'},
        ${({ theme }) => theme?.colors.greys[200] || '#E6E6E6'},
        ${({ theme }) => theme?.colors.greys[100] || '#F2F2F2'}
    );
    background-size: 400% 400%;
    -webkit-animation: ${gradientAnimation} 2.25s ease infinite;
    -moz-animation: ${gradientAnimation} 2.25s ease infinite;
    animation: ${gradientAnimation} 2.25s ease infinite;
    border-radius: 4px;
`

export const SkeletonContainer = styled('div')`
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 20px 0;
    margin: 20px 0;
`

export const TopGrid = styled('div')`
    display: grid;
    grid-template-columns: 1fr 2fr;
    gap: 24px;
    margin-bottom: 24px;
`

export const BottomGrid = styled('div')`
    display: grid;
    grid-template-columns: 2fr 1.3fr;
    gap: 24px;
`

export const SectionContainer = styled('div')`
    height: 100%;
    display: flex;
    flex-direction: column;
`

export const Card = styled('div')<{ theme?: TTheme }>`
    background: ${({ theme }) => theme?.colors.semantic.backgroundSecondary};
    border-radius: 4px;
    padding: 20px;
    box-shadow: 5px 5px 15px 0px rgba(0, 0, 0, 0.05);
    flex: 1;
`

export const AlertsCardContent = styled('div')`
    display: flex;
    gap: 24px;
    align-items: center;
`

export const ChartBlock = styled(Pulsate)`
    width: 140px;
    height: 140px;
    border-radius: 50%;
    flex-shrink: 0;
`

export const SeverityList = styled('div')`
    display: flex;
    flex-direction: column;
    gap: 12px;
    flex: 1;
`

export const SeverityRow = styled(Pulsate)`
    width: 100%;
    height: 16px;
    border-radius: 4px;
`

export const MetricGrid = styled('div')`
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 15px;
    min-height: 100px;
`

export const MetricTile = styled(Pulsate)`
    height: 100px;
    border-radius: 8px;
`

export const ListRows = styled('div')`
    display: flex;
    flex-direction: column;
    gap: 12px;
`

export const ListRow = styled(Pulsate)`
    width: 100%;
    height: 40px;
    border-radius: 4px;
`

export const ChartArea = styled(Pulsate)`
    width: 100%;
    height: 180px;
    border-radius: 4px;
`

export const TableSearchRow = styled('div')`
    display: flex;
    align-items: center;
    gap: 12px;
    margin: 12px 0;
`

export const TableSearchBar = styled(Pulsate)`
    flex: 1;
    max-width: 400px;
    height: 36px;
    border-radius: 8px;
`

export const TableFilterButton = styled(Pulsate)`
    width: 120px;
    height: 36px;
    border-radius: 8px;
`

export const TableHeader = styled('div')<{ theme?: TTheme }>`
    display: flex;
    gap: 0;
    width: 100%;
    padding: 10px 16px;
    background-color: ${({ theme }) => theme?.colors.greys[75] || '#F8F8F8'};
    border-radius: 4px;
    box-sizing: border-box;
    margin-bottom: 4px;
`

export const TableHeaderCell = styled(Pulsate)`
    flex: 1;
    height: 18px;
`

export const TableRow = styled('div')<{ theme?: TTheme }>`
    display: flex;
    gap: 0;
    width: 100%;
    padding: 14px 16px;
    border: 1px solid ${({ theme }) => theme?.colors.greys[200] || '#E6E6E6'};
    border-radius: 4px;
    box-sizing: border-box;
    margin-bottom: 4px;
`

export const TableCell = styled('div')`
    flex: 1;
    display: flex;
    align-items: center;
    padding-right: 16px;
    box-sizing: border-box;

    &:last-child {
        padding-right: 0;
    }
`

export const TableCellContent = styled(Pulsate)`
    width: 80%;
    height: 18px;
`
